import { BuildingCard } from './BuildingCard';
// import { BuildingOverallPerformance } from './BuildingOverallPerformance';
import { type Asset, type AssetTags } from 'interfaces/assets/Asset.interface';
import { type ActionItem } from '../BuildingViewPage';
import { type BuildingView } from 'interfaces/assets/Building.interface';
import { type FC } from 'react';
import clsx from 'clsx';
import { FlexAnimatedCollapse } from './FlexAnimatedCollapse';
import { FlexAnimationProvider } from '../context/FlexAnimationContext';

interface BuildingCardAndOverallPerfomanceProps {
  asset?: Asset;
  assetImpact?: BuildingView;
  tags?: AssetTags[];
  renewableEnergy?: number;
  isFetching: boolean;
  isActionRequired: ActionItem[];
  setIsActionRequired: (items: any) => void;
}

const BuildingCardAndOverallPerfomanceContent: FC<
  BuildingCardAndOverallPerfomanceProps
> = ({
  asset,
  assetImpact,
  tags,
  renewableEnergy,
  isFetching,
  isActionRequired,
  setIsActionRequired,
}) => {
  // const buildingHasOverallPerformance =
  //   assetImpact?.energy_intensity_kwh !== 0 &&
  //   assetImpact?.energy_intensity_co2 !== 0;

  // const shouldShowSkeletonForOverallPerformance =
  //   isFetching || !buildingHasOverallPerformance;
  return (
    <div className="flex gap-8 items-stretch">
      <FlexAnimatedCollapse shouldShow={true} position="left" width="75%">
        <div className={clsx('mt-[30px]', 'w-full h-full')}>
          <BuildingCard
            asset={asset}
            isFetching={isFetching}
            isActionRequired={isActionRequired}
          />
        </div>
      </FlexAnimatedCollapse>

      {/* <FlexAnimatedCollapse
        shouldShow={buildingHasOverallPerformance}
        position="right"
        width="25%"
      >
        <div className="flex flex-1 w-full h-full">
          <BuildingOverallPerformance
            building={assetImpact}
            tags={tags}
            renewableEnergy={renewableEnergy}
            isFetching={shouldShowSkeletonForOverallPerformance}
            setIsActionRequired={setIsActionRequired}
          />
        </div>
      </FlexAnimatedCollapse> */}
    </div>
  );
};

const BuildingCardAndOverallPerfomance: FC<
  BuildingCardAndOverallPerfomanceProps
> = (props) => (
  <FlexAnimationProvider initialLeftWidth="75%" initialRightWidth="25%">
    <BuildingCardAndOverallPerfomanceContent {...props} />
  </FlexAnimationProvider>
);

export default BuildingCardAndOverallPerfomance;
